// src/components/Navbar.js
import React from 'react';
import { Menu, LogOut, User, LogIn, UserPlus, HelpCircle, Shield } from 'lucide-react';
import { useAuth } from '../../context/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/images/safemcc-logo-icon-v2.png';
import logoSafeMCC from '../../assets/images/logo-safemcc.svg';

const Navbar = ({ onToggleSidebar }) => {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  // Define admin users by email - only check if user is authenticated
  const adminEmails = [
    'vyo@s360digital.com',
    'admin@s360digital.com',
    // Add other admin emails here
  ];

  // Check if current user is an admin - only if authenticated
  const isAdmin = isAuthenticated && user && adminEmails.includes(user.email);

  // Only show sidebar toggle on authenticated pages
  const showSidebarToggle = isAuthenticated && onToggleSidebar;

  return (
    <nav className="bg-white border-b border-gray-200 h-14 flex items-center px-4 justify-between">
      <div className="flex items-center space-x-4">
        {showSidebarToggle && (
          <button onClick={onToggleSidebar} className="text-gray-600 hover:text-gray-800">
            <Menu size={24} />
          </button>
        )}
        <div className="flex items-center space-x-2">
          <img 
            src={logo} 
            alt="Company Logo" 
            className="h-8 w-auto"
          />
          <h1 className="text-xl font-semibold text-gray-800">SafeMCC</h1>
        </div>
      </div>
      
      <div className="flex items-center space-x-4">
        
        {/* <button 
          onClick={() => navigate('/faq')}
          className="flex items-center space-x-2 text-gray-600 hover:text-gray-800"
        >
          <HelpCircle size={20} />
          <span>FAQ</span>
        </button> */}

        {isAuthenticated ? (
          // Authenticated user buttons
          <>
            {/* Admin Panel button - only visible to admins */}
            {isAdmin && (
              <button 
                onClick={() => navigate('/dashboard/admin')}
                className={`flex items-center space-x-2 text-gray-600 hover:text-gray-800 ${
                  location.pathname.includes('/dashboard/admin') ? 'text-blue-600' : ''
                }`}
              >
                <Shield size={20} />
                <span>Admin</span>
              </button>
            )}
            
            <button 
              onClick={() => navigate('/dashboard/profile')}
              className={`flex items-center space-x-2 text-gray-600 hover:text-gray-800 ${
                location.pathname.includes('/dashboard/profile') ? 'text-blue-600' : ''
              }`}
            >
              <User size={20} />
              <span>Profile</span>
            </button>
            
            <button 
              onClick={logout}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-800"
            >
              <LogOut size={20} />
              <span>Sign Out</span>
            </button>
          </>
        ) : (
          // Non-authenticated user buttons
          <>
            <button 
              onClick={() => navigate('/login', { state: { isRegistering: false } })}
              className={`flex items-center space-x-2 text-gray-600 hover:text-gray-800 
                ${isLoginPage && !location.state?.isRegistering ? 'text-blue-600' : ''}`}
            >
              <LogIn size={20} />
              <span>Sign In</span>
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
